
import {initWebComponent} from "@/helpers/web-component-helper";
import {
    bytesToSize,
    getFileByService,
    getFileIconByExtension,
    getFileIndexByFormID,
    setFileIndexByFormID
} from "@/helpers/file-helper";
import {
    getAttributeItemByFeatureInfo,
    getFeatureInfoByFeatureInfoKey
} from "@/helpers/plugin-helper";
import {showImageModal} from "@/components/layout/image-model-component";
import moment from "moment";
import Swal from "sweetalert2";
import {startDraw} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import {deleteFile} from "@/http/services/http-services-file";
import {reloadServiceClick} from "@/helpers/ol/ol-http-helper";
moment.locale('nl')
import { saveAs } from 'file-saver';

export class LayerInfoInfoPluginFileItemComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        const featureInfoKey = this.getAttribute('data-feature-info-key')
        const featureKey = this.getAttribute('data-feature-key')
        const domainListKey = this.getAttribute('data-domain-list-key')

        const featureInfo = getFeatureInfoByFeatureInfoKey(featureKey, featureInfoKey)
        const attributeItem = getAttributeItemByFeatureInfo(featureInfo)

        const domainID = featureInfo.DomainID
        const presentationID = featureInfo.PresentationID
        const formAttributeID = attributeItem.FormAttributeID


        let innerHTML = ``
        const domainListItem = attributeItem.DomainList.DomainListItems[domainListKey]

        console.log(featureInfo.FormID)

        setFileIndexByFormID(featureInfo.FormID)

        const fileIndex = getFileIndexByFormID(featureInfo.FormID)


        const imgSrc = window.kaartViewerUrl +  `/admin/v2/kaartviewerapi/bookmark/` + window.websiteID + `/domain/` + domainID + `/presentation/` + presentationID + `/formattribute/` + formAttributeID  + `/item/${fileIndex}/filename/` + domainListItem.Name + `?_=` + new Date().getTime()

        if(!domainListItem.Name) {
            return
        }

        const extension = domainListItem.Name.split('.')[1];
        let fileIconExtension
        if (extension !== undefined && extension !== null) {
            fileIconExtension = getFileIconByExtension(extension);
        }

        if(fileIconExtension.isImage) {
            getFileByService(imgSrc).then(blob => {
                const src = URL.createObjectURL(blob)
                initSettings(this, src, blob)
            })
        } else {
            initSettings(this, imgSrc)
        }


        function initSettings(element, src, blob = undefined) {


            innerHTML += `
          <div class="row no-gutters">
            <div class="col-12">
                  <div class="ui-bordered p-2">`

            const extension = domainListItem.Name.split('.')[1];
            let fileIconExtension
            if (extension !== undefined && extension !== null) {
                fileIconExtension = getFileIconByExtension(extension);
            }

            if(fileIconExtension.isImage) {
                innerHTML += `  
                      <img 
                            title="Klik om te vergroten" 
                            src="${src}"
                            data-src="${src}"
                            class="cursor-pointer pb-2" 
                            width="100%"
                        >`
            }

            innerHTML += `
                        <div class="media-body">
                            <a href="${src}" target="_blank" class="project-attachment-filename btnDownload" title="${domainListItem.Name}">
                                <i class="fa ${fileIconExtension.icon}"></i>  ${domainListItem.Name}
                           </a>
                            <div class="small pt-1">
                                <i class="fa fa-file-alt"></i> ` + bytesToSize(domainListItem.Size) + ` <i class="fa fa-calendar-alt ml-1"></i> ${moment.unix(domainListItem.Timestamp).format('DD MMM YYYY HH:mm')}
                            </div>
                            <div class="pt-1">
                                <a href="${src}" type="button" title="Download" class="btn btn-xs btn-warning icon-btn btnDownload">
                                    <i class="fa fa-download"></i>
                                </a>
                            `

            if(fileIconExtension.isImage) {
                innerHTML += `<button data-src="${src}" title="Vergroten" class="cursor-pointer btn btn-xs btn-warning icon-btn ml-1">
                                    <i data-src="${src}" class="fa fa-expand-arrows-alt"></i>
                                  </button>`
            }

            if(featureInfo.UserRights.includes(8)) {
                innerHTML += `
                            <button class="btn btn-xs btn-danger icon-btn ml-1 btn-danger">
                                <i class="fa fa-trash"></i>
                            </button>`
            }

            innerHTML += `    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                    `;

            template.innerHTML = innerHTML

            initWebComponent(element, template)

            element.querySelectorAll('.btnDownload').forEach(element => {
                element.addEventListener('click', (e) => {
                    e.preventDefault()

                    if(blob) {
                        saveAs(blob, domainListItem.Name);
                    } else {
                        getFileByService(src).then(blob => {
                            saveAs(blob, domainListItem.Name);
                        })
                    }
                })
            })


            element.querySelectorAll('.cursor-pointer').forEach(element => {
                element.addEventListener('click', (e) => {
                    // console.log(e.target)
                    showImageModal(e.target.dataset.src)
                })
            })
            element.querySelectorAll('.btn-danger').forEach(element => {
                element.addEventListener('click', (e) => {
                    // console.log(e.target)
                    Swal.fire({
                        buttonsStyling: false,
                        title: 'Weet u het zeker?',
                        html: 'De afbeelding <b>' + domainListItem.Name + '</b> wordt verwijderd',
                        type: 'warning',
                        showCancelButton: true,
                        customClass: {
                            confirmButton: 'btn btn-danger btn-lg',
                            cancelButton: 'btn btn-default btn-lg'
                        },
                        reverseButtons: true,
                        confirmButtonText: 'Verwijderen',
                        cancelButtonText: "Annuleren",
                    }).then(function(result) {
                        if (result.value) {
                            deleteFile(domainID, presentationID, formAttributeID, domainListKey, domainListItem).then(response => {
                                Swal.fire({
                                    buttonsStyling: false,
                                    title: 'De afbeelding is succesvol verwijderd',
                                    type: 'success',
                                    customClass: {
                                        confirmButton: 'btn btn-success btn-lg'
                                    }
                                });

                                reloadServiceClick()
                            })
                        }
                    });
                })
            })
        }
    }

}

